import styles from "./index.module.scss"

const ALERT_RULE_INPUT_ABSOLUTE_MAX = 1000

interface AlertRuleValueUnitInputProps {
  value: string
  onChange: (value: string) => void
  unit?: string
  onUnitChange?: (value: string) => void
  options?: string[]
  ariaLabel: string
  roundValue?: boolean
  min?: number
  max?: number
  errorMessage?: string
  renderError?: boolean
}

export const AlertRuleValueUnitInput = ({
  value,
  onChange,
  unit,
  onUnitChange,
  options,
  ariaLabel,
  roundValue = false,
  min,
  max,
  errorMessage,
  renderError = true,
}: AlertRuleValueUnitInputProps) => {
  const hasUnit = unit && onUnitChange && options?.length
  const inputMin = min ?? 0
  const displayValue =
    roundValue && value.trim() !== "" && !Number.isNaN(Number(value)) ? String(Math.round(Number(value))) : value

  return (
    <span className={styles.valueUnitField}>
      <span className={styles.valueUnitInput}>
        <input
          aria-label={ariaLabel}
          aria-describedby={errorMessage ? `${ariaLabel}-error` : undefined}
          aria-invalid={errorMessage ? true : undefined}
          type="number"
          step={roundValue ? 1 : undefined}
          min={inputMin}
          max={max ?? ALERT_RULE_INPUT_ABSOLUTE_MAX}
          value={displayValue}
          onChange={event => {
            const nextValue = event.target.value
            const numericValue = Number(nextValue)

            if (
              nextValue.trim() !== "" &&
              Number.isFinite(numericValue) &&
              (numericValue < 0 || (inputMin === 0 && numericValue < inputMin))
            ) {
              onChange(String(inputMin))
              return
            }

            if (!roundValue || nextValue.trim() === "" || Number.isNaN(Number(nextValue))) {
              onChange(nextValue)
              return
            }

            onChange(String(Math.round(Number(nextValue))))
          }}
          className={styles.valueUnitNumber}
        />
        {hasUnit && (
          <select
            aria-label={`${ariaLabel} unit`}
            value={unit}
            onChange={event => onUnitChange(event.target.value)}
            className={styles.valueUnitSelect}
          >
            {options.map(option => (
              <option value={option} key={option}>
                {option}
              </option>
            ))}
          </select>
        )}
      </span>
      {errorMessage && renderError && (
        <span id={`${ariaLabel}-error`} role="alert" className={styles.valueUnitError}>
          {errorMessage}
        </span>
      )}
    </span>
  )
}
